import { ElementCollection } from 'job-lib/types/Parameters'

import { ParameterOptions } from '../../types'

export interface NestedDataPickerEditorProps extends ParameterOptions {
  parameterName: string
  onDone: (editedValue: ElementCollection) => void
  elements: ElementCollection
}

export enum DataStructureType {
  VARCHAR = 'VARCHAR',
  NUMBER = 'NUMBER',
  FLOAT = 'FLOAT',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  TIMESTAMP = 'TIMESTAMP',
  TIME = 'TIME',
  VARIANT = 'VARIANT'
}

export interface SharedDataStructure {
  key: string
  children: ChildDataStructure[]
}

export interface DataStructure extends SharedDataStructure {
  type: DataStructureType.VARIANT
}

export interface ChildDataStructure extends SharedDataStructure {
  type: DataStructureType
  size: number
  decimalPlaces: number
  column: string
  alias: string
  array: boolean
  selected: boolean
}
